export default __webpack_public_path__ + "static/logo4-36432e0204ebd89358c2e29d9a52ae5a.webp";